import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configCategory/upsert/uptime.configCategory.upsert.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeConfigCategoryUpsertMutation,
  UptimeConfigCategoryUpsertMutationVariables,
} from "@/v2-backoffice-client/uptime/configCategory/upsert/__types__/uptime.configCategory.upsert.mutation"

type Options = MutationHookOptions<
  UptimeConfigCategoryUpsertMutation,
  UptimeConfigCategoryUpsertMutationVariables
>

export function useUptimeConfigCategoryUpsertMutation(options?: Options) {
  return useMutation<
    UptimeConfigCategoryUpsertMutation,
    UptimeConfigCategoryUpsertMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
